//src/components/shared/StatusBadge.tsx
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

const statusStyles: Record<string, string> = {
  // Riscos
  identificado: 'bg-warning/10 text-warning border-warning/20',
  em_analise: 'bg-info/10 text-info border-info/20',
  em_tratamento: 'bg-primary/10 text-primary border-primary/20',
  monitorado: 'bg-success/10 text-success border-success/20',
  encerrado: 'bg-muted text-muted-foreground border-border',

  // Ações
  pendente: 'bg-warning/10 text-warning border-warning/20',
  em_andamento: 'bg-info/10 text-info border-info/20',
  concluida: 'bg-success/10 text-success border-success/20',
  atrasada: 'bg-destructive/10 text-destructive border-destructive/20',
  cancelada: 'bg-muted text-muted-foreground border-border',

  // Financeiro
  trial: 'bg-accent/10 text-accent border-accent/20',
  ativa: 'bg-success/10 text-success border-success/20',
  suspensa: 'bg-warning/10 text-warning border-warning/20',
  paga: 'bg-success/10 text-success border-success/20',
  vencida: 'bg-destructive/10 text-destructive border-destructive/20',
  pago: 'bg-success/10 text-success border-success/20',
  expirado: 'bg-muted text-muted-foreground border-border',
  aprovado: 'bg-success/10 text-success border-success/20',
  recusado: 'bg-destructive/10 text-destructive border-destructive/20',
  processando: 'bg-info/10 text-info border-info/20',
  emitida: 'bg-success/10 text-success border-success/20',
  erro: 'bg-destructive/10 text-destructive border-destructive/20',
};

const statusLabels: Record<string, string> = {
  identificado: 'Identificado',
  em_analise: 'Em Análise',
  em_tratamento: 'Em Tratamento',
  monitorado: 'Monitorado',
  encerrado: 'Encerrado',
  pendente: 'Pendente',
  em_andamento: 'Em Andamento',
  concluida: 'Concluída',
  concluido: 'Concluído',
  atrasada: 'Atrasada',
  cancelada: 'Cancelada',
  cancelado: 'Cancelado',
  trial: 'Trial',
  ativa: 'Ativa',
  suspensa: 'Suspensa',
  paga: 'Paga',
  vencida: 'Vencida',
  pago: 'Pago',
  expirado: 'Expirado',
  aprovado: 'Aprovado',
  recusado: 'Recusado',
  estornado: 'Estornado',
  processando: 'Processando',
  emitida: 'Emitida',
  erro: 'Erro',
};

interface StatusBadgeProps {
  status: string;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={cn('text-xs font-medium', statusStyles[status] || '', className)}
    >
      {statusLabels[status] || status}
    </Badge>
  );
}
